/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict"

    interface ITestPrep {
    }

    interface ITestPrepScope extends ng.IScope {
        vm: TestPrep;
    }

    interface Prospect {
        additionalData: any;
    }

    class TestPrep implements ITestPrep {
        static $inject: Array<string> = ["common", "Restangular", "$scope", "$location", "$rootScope","config"];
        static controllerId: string = "testPrep";
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        firstName: string;
        middleName: string;
        user: any;

        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private $scope: ITestPrepScope, private $location: ng.ILocationService, private $rootScope: ng.IRootScopeService, private config: IConfig) {
            this.log = common.logger.getLogFn(TestPrep.controllerId);
            this.logError = common.logger.getLogFn(TestPrep.controllerId, "error");

            var test = this.$rootScope.$on(this.config.events.login,
                (data: any): void => {
                    sessionStorage.setItem("loginRedirect", "true");
                });

            var test2 = this.$rootScope.$on(this.config.events.logout,
                (data: any): void => {
                    sessionStorage.removeItem("loginRedirect");
                });


            this.activate();
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, TestPrep.controllerId)
                .then(() => {
                    this.log("Activated Test Prep page");
                    var login = sessionStorage.getItem("loginRedirect");
                    if (login) {
                        this.openCfncTools();
                        sessionStorage.removeItem("loginRedirect");
                    }
                });
        }

        openCfncTools() {
            this.Restangular.one("users/testPrepProfile").get()
                .then((result) => {
                    if (result) {
                        this.user = result;
                        var hostName = "testprep.ncmentor.org";
                        window.open('http://' + hostName + '/partner/handoff/index.cfm?pud=' + this.user.userId + '&hud=' + this.user.userIdHash + '&email=' + this.user.email + '&first_name=' + this.user.firstName,
                            'popwin','menubar=no,directories=no,personalbar=no,resizable=yes,scrollbars=yes,status=no,toolbar=yes,width=750,height=500');
                    }
                }, (reason) => {
                    this.logError(reason, reason, true);
                });
        }
    }
    angular.module("app").controller(TestPrep.controllerId, TestPrep);
} 